import { apiClient } from "api";
import { TProvider, TProviderPicklist } from "./models/types";

export const getAllProvidersList = async (accountId: string): Promise<TProviderPicklist[]> => {
  return apiClient.get(`providers/list/${accountId}`).then(reponse => reponse.data);
};

export async function getProvidersForAccount(accountId: string): Promise<TProvider[]> {
  const response = await apiClient.get(`providers/GetProvidersForAccount`, {
    params: { accountId: accountId }
  });
  return response.data;
}

export async function addProvider(provider: TProvider): Promise<number> {
  console.log(provider);
  return apiClient({
    method: "post",
    url: `providers/InsertProvider`,
    data: provider
  });
}

export async function updateProvider(provider: TProvider): Promise<number> {
  console.log(provider);
  return apiClient({
    method: "put",
    url: `providers/UpdateProvider`,
    data: provider
  });
}
